// extracted by mini-css-extract-plugin
export default {"table":"style_table__z7kfz","loadingBox":"style_loadingBox__kQJl6"};